import {useState} from "react";

const FeedbackModal: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    aff: "",
    message: "",
    subject: "Feedback",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const sendFormDataToAPI = async (name, email, aff, message, subject) => {
    try {
      const API_URL = import.meta.env.VITE_REACT_APP_API_URI;
      const response = await fetch(`${API_URL}/Mail`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({name, email, aff, message, subject}),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();
      console.log("API Response:", responseData);
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };

  const handleSubmit = () => {
    console.log("Form Data:", formData);
    sendFormDataToAPI(
      formData.name,
      formData.email,
      formData.aff,
      formData.message,
      formData.subject,
    );
    document.getElementById("feedback").close();
  };

  return (
    <dialog id="feedback" className="modal">
      <div className="modal-box flex justify-between flex-col h-[20vw] items-end min-h-fit max-w-fit">
        <div className="flex flex-row">
          <div className="text-valmidnight text-[15px]">Name: </div>
          <textarea
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="grow h-auto border-2 ml-2 border-valmidnight resize-y rounded-md min-w-[23vw]"></textarea>
        </div>

        <div className="flex flex-row">
          <div className="text-valmidnight text-[15px]">Email: </div>
          <textarea
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="grow h-auto border-2 ml-2 border-valmidnight resize-y rounded-md min-w-[23vw]"></textarea>
        </div>

        <div className="flex flex-row">
          <div className="text-valmidnight text-[15px]">Affiliation: </div>
          <textarea
            name="aff"
            value={formData.aff}
            onChange={handleChange}
            className="grow h-auto border-2 ml-2 border-valmidnight resize-y rounded-md min-w-[23vw]"></textarea>
        </div>

        <div className="flex flex-row">
          <div className="text-valmidnight text-[15px]">Message: </div>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="grow h-auto border-2 ml-2 border-valmidnight min-h-[5vw] resize-y rounded-md min-w-[23vw]"></textarea>
        </div>

        <div className="modal-action">
          <form method="dialog">
            <button
              type="button"
              className="btn border-none"
              onClick={handleSubmit}>
              Submit
            </button>
            <button className="btn border-none">Cancel</button>
          </form>
        </div>
      </div>
    </dialog>
  );
};

export default FeedbackModal;
